import { render, staticRenderFns } from "./BestOdds.vue?vue&type=template&id=49b24d51"
import script from "./BestOdds.vue?vue&type=script&lang=js"
export * from "./BestOdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports